<template>
  <div class="icon-datepicker">
    <div @click="show=true" class="input" :class="{'active':show,'error':error&&!show}">
      <img :src="image" alt />
      <div>
        <div v-if="label">{{label}}</div>
        <div style="min-height:1.5rem;" class="text-label">{{value | ToDate}}</div>
      </div>
    </div>
    <modal
      size="20"
      v-show="show"
      :padding="false"
      v-on="$listeners"
      @escape="hideModal"
      @complete="hideModal"
      @click-mask="hideModal"
    >
      <div slot="body">
        <datepicker @change="datepickerChange" :min="min" :max="max" :current="value" />
      </div>
    </modal>
  </div>
</template>
<script>
import moment from "moment";
import validatable from "../validatable";
import Modal from "@/components/layout/Modal";
export default {
  inheritAttrs: false,
  mixins: [validatable],
  name: "icon-datepicker",
  components: {
    Modal
  },
  props: {
    min: String,
    max: String,
    label: String,
    image: String,
    value: String
  },
  data() {
    return {
      show: false
    };
  },
  filters: {
    ToDate(val) {
      if (val) {
        return moment(val).format("YYYY MMM DD");
      }
      return "";
    }
  },
  methods: {
    datepickerChange(val) {
      this.show = false;
      let current = moment(new Date(val)).format("YYYY-MM-DD");
      this.$emit("input", current);
      this.$emit("change", current);
    },
    hideModal() {
      this.show = false;
    }
  }
};
</script>